// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Container for each summary analysis block */
.summary-analysis-block {
    margin: 20px 0;
}

/* Title for class pair section */
.class-pair-title {
    color: #2c3e50;
    font-size: 1.2em;
    font-weight: 500;
    margin-bottom: 15px;
    padding: 8px 15px;
    background: #f0f2f5;
    border-radius: 4px;
    display: inline-block;
}
    
/* Container for summary images */
.summary-image-container {
    margin-top: 10px;
}`, "",{"version":3,"sources":["webpack://./src/css/step8_3-showStatistics.css"],"names":[],"mappings":"AAAA,8CAA8C;AAC9C;IACI,cAAc;AAClB;;AAEA,iCAAiC;AACjC;IACI,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA,iCAAiC;AACjC;IACI,gBAAgB;AACpB","sourcesContent":["/* Container for each summary analysis block */\n.summary-analysis-block {\n    margin: 20px 0;\n}\n\n/* Title for class pair section */\n.class-pair-title {\n    color: #2c3e50;\n    font-size: 1.2em;\n    font-weight: 500;\n    margin-bottom: 15px;\n    padding: 8px 15px;\n    background: #f0f2f5;\n    border-radius: 4px;\n    display: inline-block;\n}\n    \n/* Container for summary images */\n.summary-image-container {\n    margin-top: 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
